import React, { useMemo, useEffect } from "react";
import { connect } from "react-redux";
import {
  VictoryGroup,
  VictoryAxis,
  VictoryChart,
  VictoryLegend,
  VictoryBar,
  VictoryLabel,
  VictoryTheme,
} from "victory";
import { dataActions } from "_actions";

const Chart = ({ mifiTable, cpeEndTable, btsEndTable, graphData, setVal }) => {
  const MIFICostPerYear =
    +mifiTable.mifiMonthlyCharge.val *
    +mifiTable.statisticNumberConnections.val *
    12;
  const FWACostPerYear =
    +cpeEndTable.cpeEndMonthlyCharge.val *
    +mifiTable.statisticNumberConnections.val *
    12;
  const MIFICostPerYearFirst =
    +mifiTable.mifiDeviceCost.val * +mifiTable.statisticNumberConnections.val +
    MIFICostPerYear;
  const FWACostPerYearFirst =
    +btsEndTable.btsEndInfrastructureCost.val +
    +btsEndTable.btsEndApAntennaCost.val +
    +mifiTable.statisticNumberConnections.val *
      (+cpeEndTable.cpeEndInstallationTimeCost.val +
        +cpeEndTable.cpeEndOneTimeCost.val) +
    FWACostPerYear;

  let yearsCalc = useMemo(() => {
    const res = [
      {
        year: 1,
        MIFI: MIFICostPerYearFirst,
        FWA: FWACostPerYearFirst,
        savingFWA: MIFICostPerYearFirst - FWACostPerYearFirst,
      },
    ];
    for (let i = 2; i <= 10; i++) {
      res.push({
        year: i,
        MIFI: MIFICostPerYear,
        FWA: FWACostPerYear,
        savingFWA: MIFICostPerYear - FWACostPerYear,
      });
    }
    return res;
  }, [
    MIFICostPerYearFirst,
    FWACostPerYearFirst,
    FWACostPerYear,
    MIFICostPerYear,
  ]);

  useEffect(() => {
    const result = JSON.stringify(graphData) !== JSON.stringify(yearsCalc);
    result && setVal("graphData", yearsCalc);
  }, [graphData, setVal, yearsCalc]);

  if (graphData.length) {
    const getMIFIData = () => {
      return graphData.map((el) => {
        return { x: el.year, y: el.MIFI };
      });
    };
    const getFWAData = () => {
      return graphData.map((el) => {
        return { x: el.year, y: el.FWA };
      });
    };
    return (
      <div>
        <VictoryChart
          domainPadding={{ x: 10 }}
          width={350}
          height={220}
          theme={VictoryTheme.material}
        >
          <VictoryLabel
            x={350 / 2}
            y={30}
            textAnchor="middle"
            text="Cost ($) / Year"
            style={{ fontSize: 9, fontWeight: 700 }}
          />
          <VictoryGroup
            offset={10}
            style={{ data: { width: 10 } }}
          >
            <VictoryBar color="#c77300" barWidth={10} data={getMIFIData()} />
            <VictoryBar color="#153d79" barWidth={10} data={getFWAData()} />
            <VictoryAxis
              tickCount={12}
            />
            <VictoryAxis dependentAxis tickCount={6} />
          </VictoryGroup>
          <VictoryLegend
            x={110}
            y={200}
            className="aaa"
            symbolSpacer={6}
            orientation="horizontal"
            style={{
              labels: { fontSize: 8 },
            }}
            data={[
              { name: "MiFI", symbol: { fill: "#c77300" } },
              { name: "Fixed Wireless", symbol: { fill: "#153d79" } },
            ]}
          />
        </VictoryChart>
      </div>
    );
  } else {
    return "";
  }
};

const mapStateToProps = (state) => {
  return state.dataStore;
};

const mapDispatchToProps = {
  setVal: dataActions.setVal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Chart);
